import { render, staticRenderFns } from "./intervie.vue?vue&type=template&id=da5b071a&scoped=true&"
import script from "./intervie.vue?vue&type=script&lang=js&"
export * from "./intervie.vue?vue&type=script&lang=js&"
import style0 from "./intervie.vue?vue&type=style&index=0&id=da5b071a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5b071a",
  null
  
)

component.options.__file = "intervie.vue"
export default component.exports